import { SpinningLoader } from "risa-oasis-ui_v2";
import type { SupportTicketComment } from "../supportTicketTypes";
import SupportTicketCommentItem from "./supportTicketCommentItem";

/**
 * Props for {@link SupportTicketCommentsList}.
 */
interface SupportTicketCommentsListProps {
  comments: SupportTicketComment[];
  /** Whether comments are being submitted or refreshed. */
  loading?: boolean;
}

/**
 * Scrollable list of support ticket comments.
 *
 * @param props - Comment thread items and loading state.
 * @returns Vertical comment timeline.
 */
const SupportTicketCommentsList = ({
  comments,
  loading = false,
}: SupportTicketCommentsListProps) => {
  if (loading) {
    return (
      <div className="support-tickets-comments-list flex min-h-0 flex-1 flex-col items-center justify-center gap-2 px-4 py-3">
        <SpinningLoader />
        <div className="text-sm text-primaryGray-7">Adding comment...</div>
      </div>
    );
  }

  if (comments.length === 0) {
    return (
      <div className="support-tickets-comments-list flex min-h-0 flex-1 items-center justify-center px-4 py-3 text-sm text-primaryGray-7">
        No Comments to Show
      </div>
    );
  }

  return (
    <div className="support-tickets-comments-list flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 py-3">
      {comments.map((comment) => (
        <SupportTicketCommentItem key={comment.id} comment={comment} />
      ))}
    </div>
  );
};

export default SupportTicketCommentsList;
